import PropTypes from 'prop-types';
import { rem } from 'polished';
import { Box } from '@qga/roo-ui/components';
import { H3 } from './primitives';
import { H2 } from '../primitives';
import { BreakOnNewLine } from 'components/Typography';

const ARRIVAL_INSTRUCTIONS =
  'Guest must provide one form of photo identification (drivers license, passport, age card,company ID,etc) for proof to match the genuity of guest (s) identification in relation to booking; and that the Management will retain a copy of such ID.Failure to produce these items means cancellation of booking.';

const KnowBeforeYouGo = ({ checkInInstructions, hotelPolicies, cancellationPolicy }) => (
  <Box as="article">
    <H2>Know before you go</H2>
    <H3>Arrival instructions</H3>
    <BreakOnNewLine fontSize={rem(14)} color="emperor" my={1} dangerouslySetInnerHTML={{ __html: ARRIVAL_INSTRUCTIONS }} />
    {checkInInstructions && (
      <BreakOnNewLine fontSize={rem(14)} color="emperor" my={1} dangerouslySetInnerHTML={{ __html: checkInInstructions }} />
    )}
    {hotelPolicies && (
      <>
        <H3>Hotel policies</H3>
        <BreakOnNewLine fontSize={rem(14)} color="emperor" my={1} dangerouslySetInnerHTML={{ __html: hotelPolicies }} />
      </>
    )}
    {cancellationPolicy && (
      <>
        <H3>Cancellation policy</H3>
        <BreakOnNewLine fontSize={rem(14)} color="emperor" my={1} dangerouslySetInnerHTML={{ __html: cancellationPolicy }} />
      </>
    )}
  </Box>
);

KnowBeforeYouGo.propTypes = {
  checkInInstructions: PropTypes.string,
  hotelPolicies: PropTypes.string,
  cancellationPolicy: PropTypes.string,
};

export default KnowBeforeYouGo;
